module.exports = __webpack_public_path__ + "fonts/Flaticon2.2b7289d.ttf";